import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../../context";
import MerchantSaveDeliveryUnsave from "./MerchantSaveDeliveryUnsave";
// import MerchantSavePOUnsave from "./MerchantSavePOUnsave";

const MerchantAddDeliveryOrder = ({ close, getMerchantOrderSaveList }) => {
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const [drUnsaveList, setDRUnsaveList] = useState({
    data: [],
    ready: false,
  });
  const [specProductInfo, setSpecProductInfo] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [form] = Form.useForm();
  const [selectedData, setSelectedData] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [inputedQuantityConversion, setInputedQuantityConversion] = useState(0);

  const columns = [
    {
      title: "Product",
      dataIndex: ["deliveryunsaveproductinfo", "product"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: ["deliveryunsaveproductinfo", "description"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Expiry",
      dataIndex: "expiry_date",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Qty/Grams",
      dataIndex: "quantity",
      align: "right",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  //GOODS
  const getProductList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/product-list", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  //GOODS
  const getDeliveryUnsaveList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/delivery-unsave-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setDRUnsaveList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const handleFetchProduct = (prodID) => {
    var params = {
      id: prodID,
      user_id: userData.data.id,
    };
    setSpecProductInfo({ data: [], ready: false });
    axios
      .get("user/merchant/spec-product-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setSpecProductInfo({ data, ready: true });
        form.setFieldsValue({
          expiry_date: "",
          quantity: "",
        });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getProductList();
    getDeliveryUnsaveList();
  }, [getProductList, getDeliveryUnsaveList]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteProductInPO();
    }, 2000);
  };

  //GOODS
  const handleDeleteProductInPO = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    setLoadings(true);
    axios
      .post("user/merchant/delete-product-in-delivery", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete product successfully.");
          setTimeout(() => {
            setLoadings(false);
            getDeliveryUnsaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  //GOODS
  const handleAddProductTo = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/new-delivery-product-unsave", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "product-exist") {
          rerunNotif("error", "Product already added!");
          setTimeout(() => {
            form.setFieldsValue({
              expiry_date: "",
              quantity: 0,
            });
            setLoadings(false);
            setLoading(false);
          }, 1000);
        }
        if (data === "success") {
          rerunNotif("success", "Created new delivery successfully.");
          setTimeout(() => {
            form.setFieldsValue({
              expiry_date: "",
              quantity: "",
            });
            setLoadings(false);
            setLoading(false);
            getDeliveryUnsaveList();
          }, 1000);
        }
        setInputedQuantityConversion(0);
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <Button type="primary" icon={<CloseOutlined />} onClick={() => close()}>
          Close
        </Button>
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={16}>
          <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
            <div style={{ padding: 10 }}>
              <div style={{ marginBottom: 10 }}>
                <Typography.Title level={4}>
                  Creating Delivery Order
                </Typography.Title>
              </div>
              <div style={{ overflowX: "auto" }}>
                <Table
                  {...tableProps}
                  pagination={{
                    position: ["bottomCenter"],
                  }}
                  columns={tableColumns}
                  dataSource={
                    drUnsaveList.data.length > 0 ? drUnsaveList.data : []
                  }
                  scroll={scroll}
                  rowKey={(record) => record.id}
                />
                <div
                  style={{
                    display: drUnsaveList.data.length > 0 ? "flex" : "none",
                  }}
                >
                  <div style={{ flexGrow: 1 }} />
                  <div>
                    <Button
                      type="primary"
                      loading={loadings}
                      //   htmlType="submit"
                      //   style={{ width: "100%", borderRadius: "20px" }}
                      onClick={() => setOpenDrawer(true)}
                    >
                      {loadings ? "Loading" : "Create"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
            <div style={{ padding: 10 }}>
              <div style={{ marginBottom: 10 }}>
                <Typography.Title level={4}>Add Product</Typography.Title>
              </div>
              <div>
                <Form
                  form={form}
                  layout="vertical"
                  name="add-product"
                  initialValues={{ remember: true }}
                  onFinish={handleAddProductTo}
                  autoComplete="off"
                >
                  <Space
                    direction="vertical"
                    style={{
                      width: "100%",
                      margin: 0,
                    }}
                  >
                    <Form.Item
                      name="product"
                      label="Product"
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select product"
                        onChange={
                          (e) => handleFetchProduct(e)
                          // console.log("EVENT", e)
                        }
                        size="large"
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {productList.data.length > 0 ? (
                          productList.data.map((data, index) => (
                            <Select.Option value={data.id} key={index}>
                              {data.product}
                            </Select.Option>
                          ))
                        ) : (
                          <Select.Option value="">
                            No raw product found!
                          </Select.Option>
                        )}
                      </Select>
                    </Form.Item>

                    {console.log(
                      "specProductInfo.ready && specProductInfo.data ",
                      specProductInfo.ready && specProductInfo.data
                    )}

                    {specProductInfo.ready && specProductInfo.data && (
                      <>
                        <Form.Item
                          name="expiry_date"
                          label="Expiry Date"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <DatePicker
                            format={"MM/DD/YYYY"}
                            size="large"
                            style={{ width: "100%" }}
                          />
                        </Form.Item>

                        <Form.Item
                          name="quantity"
                          label={
                            specProductInfo.ready &&
                            parseFloat(specProductInfo.data.is_per_piece) === 1
                              ? "Quantity"
                              : "Grams"
                          }
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <InputNumber
                            min={1}
                            max={999999999999}
                            value={inputedQuantityConversion}
                            size="large"
                            style={{ width: "100%" }}
                            step="1"
                            onChange={(value) => {
                              if (value === null) {
                                setInputedQuantityConversion(0);
                              } else {
                                setInputedQuantityConversion(value);
                              }
                            }}
                          />
                        </Form.Item>
                      </>
                    )}
                  </Space>

                  <Form.Item style={{ marginTop: "20px" }}>
                    <Button
                      type="primary"
                      loading={loadings}
                      htmlType="submit"
                      style={{ width: "100%", borderRadius: "20px" }}
                      disabled={parseInt(inputedQuantityConversion) === 0}
                    >
                      {loadings ? "Loading" : "Add"}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {openDrawer && (
        <MerchantSaveDeliveryUnsave
          originaTab={() => close()}
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getDeliveryUnsaveList={() => getDeliveryUnsaveList()}
          getMerchantOrderSaveList={() => getMerchantOrderSaveList()}
        />
      )}

      <Modal
        title="Are you sure to delete this product?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      />
    </>
  );
};

export default MerchantAddDeliveryOrder;
